module.exports = __webpack_public_path__ + "assets/57bdaa0ff15f52a75977291c41a6adb3.finish_shift.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/finish_shift.png
 ** module id = 831
 ** module chunks = 1
 **/